<template>
  <div class="electricFence">
    <!-- <header-bar></header-bar> -->
  <div class="Elecheader">

  <div class="Elecsel">
     {{$t('message.partner')}}：
           <!-- <select-menu :partData="partData" @change="changeHandler"></select-menu> -->
            <el-select v-model="valuePa" placeholder="请选择" @change="changeHandler" class="selectCss" filterable>
            <el-option
             v-for="(item,index) in partData"
             :key="index"
             :label="item.loginName"
             :value="item.partnerNo">
            </el-option>
          </el-select>
          {{$t('message.area')}}：
          <!-- <select-men :areaData="areaData" @change="changeArea"></select-men> -->
           <el-select v-model="valueAr" placeholder="请选择" @change="changeArea" class="selectCss" filterable>
           <el-option
            v-for="(item,index) in areaData"
            :key="index"
            :label="item.Partnerareaname"
            :value="item.partnerareaguid">
          </el-option>
         </el-select>
          <el-dropdown @command="userOperation" class="dropName">
                        <span class="user">{{this.$cookies.get("LoginName")}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown" class="dropst">
                            <el-dropdown-item command="editPsd">{{$t('message.changePSD')}}</el-dropdown-item>
                             <!-- <el-dropdown-item command="editSecPsd">{{$t('message.changeSecPSD')}}</el-dropdown-item> -->
                            <el-dropdown-item command="logout">{{$t('message.exit')}}</el-dropdown-item>
                        </el-dropdown-menu>
            </el-dropdown>
        </div>
        <lang-select class="drops" @handIt="loadAgain"></lang-select>
    </div>
    <div class="Elecmain">
      <el-row :gutter="20">
          <el-col :span="6">
            <div>
               <electric-f-card :title="WlName" :msg="areaDaa" :t1="1" @areaSHow="areaSHows"></electric-f-card>
               <electric-f-card :title="JTArea" :msg="jtDaa" :t1="2" @areaSHow="areaSHows"></electric-f-card>
               <electric-f-card :title="Park" :msg="parkDaa" :t1="3" @areaSHow="areaSHows"></electric-f-card>
               <electric-f-card :title="JYArea" :msg="jyDaa" :t1="4" @areaSHow="areaSHows"></electric-f-card>
            </div>
            <div>
                <el-button type="primary" class="elecBbb" @click="showALL">{{$t('message.disAllDa')}}</el-button>
                <el-button type="danger" class="elecBbb" @click="EditMap">{{$t('message.editWL')}}</el-button>
            </div>
           
          </el-col>
          <el-col :span="18">
          
            <div class="map">
                 <div class="amap-wrapper" :style="{height:curHeightemap+'px'}">
                  <el-amap class="amap-box" :vid="'amap-vue'" :zoom="zoom" :amap-manager="amapManager" :plugin="plugin">
                  
                  </el-amap>
                 </div>
            </div>
           

             <!-- 编辑围栏弹窗 -->
             <el-dialog
              :title="$t('message.editWL')"
              :visible.sync="editFence"
              width="86%"
              top="12"
              :fullscreen="true"
              :before-close="handleCloseFence">
               <el-dialog
                 width="35%"
                 :title="$t('message.sureAdd')"
                 :visible.sync="saveLayer"
                 :before-close="handleCloseSLay"
                 append-to-body>
                 <div>{{$t('message.setName')}}<el-input v-model="snameInput" class="setInput"></el-input></div>
                 <div class="saveBtnG">
                    <el-button type="primary" @click="SaveLForm">{{$t('message.save')}}</el-button>
                    <el-button type="danger" @click="CloseForm">{{$t('message.cancels')}}</el-button>
                 </div>
                </el-dialog>
                <el-dialog
                 width="35%"
                 :title="$t('message.editsx')"
                 :visible.sync="editRadius"
                 :before-close="handleCloseSLay"
                 append-to-body>
                 <el-form ref="form" :model="form" label-width="80px">
                   <el-form-item :label="$t('message.named')">
                     <el-input v-model="form.name" :placeholder="$t('message.enterName')"></el-input>
                   </el-form-item>
                   <el-form-item :label="$t('message.setRadius')">
                     <el-input v-model="form.radius" :placeholder="$t('message.BanjLesten')"></el-input>
                   </el-form-item>
                   <el-form-item :label="$t('message.rem')">
                     <el-input v-model="form.rems" :placeholder="$t('message.enterRem')"></el-input>
                   </el-form-item>

                   <el-form-item>
                     <el-button type="primary" @click="SaveEditForm">{{$t('message.save')}}</el-button>
                     <el-button @click="CloseEditForm">{{$t('message.cancels')}}</el-button>
                   </el-form-item>
                 </el-form>
                </el-dialog>
                 <el-dialog
                 width="35%"
                 :title="$t('message.sysTit')"
                 :visible.sync="delRadius"
                 :before-close="handleCloseSLay"
                 append-to-body>
                <div>{{$t('message.suerDel')}}</div>
                 <div class="saveBtnG">
                    <el-button type="primary" @click="deleRadius">{{$t('message.sure')}}</el-button>
                    <el-button type="danger" @click="cancelDelRadius">{{$t('message.cancels')}}</el-button>
                 </div>
                </el-dialog>
                <el-dialog
                 width="35%"
                 :title="$t('message.sysTit')"
                 :visible.sync="moveRadius"
                 :before-close="handleCloseSLay"
                 append-to-body>
                <div>{{$t('message.suerNewLoa')}}</div>
                 <div class="saveBtnG">
                    <el-button type="primary" @click="moveRaduis">{{$t('message.sure')}}</el-button>
                    <el-button type="danger" @click="cancelMovRadius">{{$t('message.cancels')}}</el-button>
                 </div>
                </el-dialog>
                <el-dialog
                 width="35%"
                 :title="$t('message.editWL')"
                 :visible.sync="editLayer"
                 :before-close="handleCloseSLay"
                 append-to-body>
                 <div>{{$t('message.setName')}}<el-input v-model="editLayInput" class="setInput"></el-input></div>
                 <div class="saveBtnG">
                   <el-button type="success" @click="delLayer" v-if="delLAYs">{{$t('message.dele')}}</el-button>
                    <el-button type="primary" @click="saveLays">{{$t('message.save')}}</el-button>
                    <el-button type="danger" @click="CloseLForm">{{$t('message.cancels')}}</el-button>
                 </div>
                </el-dialog>
             <div class="map">
                <div class="editMaps">
                  <!-- <div class="map" id="map"></div> -->
                  <el-amap-search-box class="FindsearchBox" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
                  <el-amap class="amap-box" :vid="'amap-evue'" :zoom="zoom" :amap-manager="amapManager" :plugin="plugin" :events="events" ref="map">
                  
                  </el-amap>
                 </div>
             </div>
             <div class="BtnBox">
                 <el-select v-model="value" placeholder="请选择" @change="changeWL">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                   </el-option>
                 </el-select>
                 <span class="hz">{{$t('message.drwa')}}</span>
                 <el-button-group>
                   <!-- <el-button type="primary" @click="Drow(this,3)" v-if="showAreaOp">{{$t('message.operationArea')}}</el-button> -->
                   <el-button type="primary" @click="Drow(this,3,3)" v-if="showAreaOut">{{$t('message.areaOut')}}</el-button>
                   <el-button type="primary" @click="Drow(this,3,3.1)" v-if="showAreaIn">{{$t('message.areaIn')}}</el-button>
                   <el-button type="primary" @click="Drow(this,5,'')">{{$t('message.jtArea')}}</el-button>
                   <el-button type="primary" @click="Drow(this,2,'')">{{$t('message.jyParkArea')}}</el-button>
                   <el-button type="primary" @click="Drow(this,1,'')" v-show="showParK">{{$t('message.parking')}}</el-button>
                   <!-- <el-button type="primary" @click="startEditYYPolygon" :disabled="yyDisFive">{{$t('message.startEditFen')}}</el-button> -->
                    <el-button type="primary" @click="startEditYYPolygon(3)" :disabled="yyOutDisFive">{{$t('message.editAreaOut')}}</el-button>
                     <el-button type="primary" @click="startEditYYPolygon(3.1)" :disabled="yyInDisFive" v-if="inButton" >{{$t('message.editAreaIn')}}</el-button>
                   <el-button type="primary" @click="startEditJTPOlygon" :disabled="jtDisFive">{{$t('message.startEditJTA')}}</el-button>
                   <el-button type="primary" @click="startEditJYPOlygon" :disabled="jyDisFive">{{$t('message.startEditJYA')}}</el-button>
                   <el-button type="primary" @click="closeEditPolygon">{{$t('message.endEditFen')}}</el-button>
                 </el-button-group>
                 <el-switch
                   v-model="value2"
                   active-color="#13ce66"
                   class="switch"
                   @change="switchChange"
                   inactive-color="#b2b2b2">
                 </el-switch>
                 <span class="Moving">{{MoveCan}}</span>
                 
             </div>
             <div class="boxFot">
                   <el-card class="box-card boxTox">
                    <!-- <div>运营区域（内）：<span class="ftAreaIn"></span></div>  -->
                    <span class="s1" style="color:red">注：无断电区域，忽略围栏以及断电</span>
                    <span class="s1">运营区域（外--断电）：<span class="ftAreaOut"></span></span> 
                    <span class="s1">内围栏（报语音--无）：<span class="ftAreaOut1"></span></span> 
                    <span class="s1">禁停区域：<span class="ftAreaJT"></span></span> 
                    <span class="s1">停车区：<span class="ftAreaJY"></span></span> 
                   </el-card>
              </div>
              <span slot="footer" class="dialog-footer">
              </span>
            </el-dialog>
             <el-dialog
               :title="$t('message.sysTit')"
               :visible.sync="delTis"
               width="20%"
               >
               <span>{{$t('message.suerDel')}}</span>
               <span slot="footer" class="dialog-footer">
               <el-button @click="delTis = false">{{$t('message.cancels')}}</el-button>
               <el-button type="primary" @click="suerDelete">{{$t('message.sure')}}</el-button>
               </span>
             </el-dialog>
          </el-col>
      </el-row>
     
    
    
     </div>
      <el-dialog
      :title="$t('message.changePSD')"
      :visible.sync="editPSDS"
      width="24%"
      >
      <el-form ref="form" :model="formm" label-width="80px">
       <el-form-item :label="$t('message.oldPSD')">
        <el-input v-model="formm.oldpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.newPSD')">
        <el-input v-model="formm.newpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.suerPSD')">
        <el-input v-model="formm.surepsd" type="password"></el-input>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="editPSDS = false">{{$t('message.cancels')}}</el-button>
      <el-button type="primary" @click="changePsds">{{$t('message.sure')}}</el-button>
      </span>
     </el-dialog>

     

     <el-dialog
      :title="$t('message.changeSecPSD')"
      :visible.sync="editSecPSDS"
      width="26%"
      >
      <el-form ref="form" :model="formmSec" label-width="100px">
       <el-form-item :label="$t('message.oldSecPsd')">
        <el-input v-model="formmSec.oldpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.newSecPsd')">
        <el-input v-model="formmSec.newpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.suerSecPsd')">
        <el-input v-model="formmSec.surepsd" type="password"></el-input>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="editSecPSDS = false">{{$t('message.cancels')}}</el-button>
      <el-button type="primary" @click="changeSecPsds">{{$t('message.sure')}}</el-button>
      </span>
     </el-dialog>

     <el-dialog
        :title="$t('message.sysTit')"
        :visible.sync="dialogOuti"
        width="30%"
      >
       <span>{{soneIns}}</span>
       <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOuti = false">{{$t('message.cancels')}}</el-button>
        <el-button type="primary" @click="logout">{{$t('message.sure')}}</el-button>
       </span>
      </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import md5 from "js-md5";
import SelectMenu from "@/components/SelectMenu.vue";
import SelectMen from "@/components/SelectMen.vue";
import LangSelect from "@/components/LangSelect.vue";
import ElectricFCard from "@/components/ElectricFCard.vue";

import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
var epolygon;
var polygonEditor;
var polygonAllArr = [];
var showPoint = 0; //是否正在抓取点坐标　0　表示不抓取点
var LayType = -1; //绘制图层类型   1 运营区域　2　禁停区域　3　停车点
var mouseTool;
var autoOptions; //输入提示
var auto; //输入提示
var placeSearch; //输入提示
export default {
  name: "ElectricFence",
  data() {
    var self = this;
    return {
      curHeightemap:document.documentElement.clientHeight || document.body.clientHeight,
      isOutterGeofencing: "yes",
      showAreaOut: true,
      showAreaIn: true,
      jyDaa: "",
      yyInDisFive: false,
      yyOutDisFive: false,
      yyDisFive: false,
      jtDisFive: false,
      jyDisFive: false,

      editELEGuid: "",
      soneIns: "",
      dialogOuti: false,
      editSecPSDS: false,
      formmSec: {
        oldpsd: "",
        newpsd: "",
        surepsd: ""
      },
      valuePa: "",
      valueAr: "",
      editPSDS: false,
      formm: {
        oldpsd: "",
        newpsd: "",
        surepsd: ""
      },
      partData: "",
      areaData: "",
      WlName: "",
      areaDaa: "",
      jtDaa: "",
      parkDaa: "",
      PageType: "-1",
      editFence: false,
      searchInput: "",
      snameInput: "",
      editLayInput: "",
      amapManager,
      zoom: 14,
      center: [],
      plugin: ["ToolBar"],
      SavePoint: "",
      saveLayer: false,
      editRadius: false,
      delRadius: false,
      moveRadius: false,
      editLayer: false,
      delTis: false,
      delLAYs: true,
      OperatingArea: "",
      radiusGuid: "",
      moveGuid: "",
      nEwpoint: "",
      layGuid: "",
      form: {
        name: "",
        radius: "",
        rems: ""
      },
      searchOption: {
        city: ""
      },

      events: {
        init(map) {
          mouseTool = new AMap.MouseTool(map);
        },
        click: e => {
          console.log('啦啦啦',e);
          if (showPoint == 1) {
            if (LayType == 3 || LayType == 5 || LayType == 2) {
              this.SavePoint +=
                "[" + e.lnglat.getLng() + "," + e.lnglat.getLat() + "],";
            } else if (LayType == 1) {
              var guid = this.newGuid();
              var point =
                "[" + e.lnglat.getLng() + "," + e.lnglat.getLat() + "]";
              this.eddMark(guid, point);
              // console.log(point);
              var params = new URLSearchParams();
              params.append("languagecode", this.$i18n.locale);
              params.append("timestamp", this.GLOBAL.timestamp);
              params.append(
                "securitykey",
                md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
              );
              params.append("Token", this.$cookies.get("Token"));
              params.append("id", this.$cookies.get("ID"));
              params.append("partnerareaguid", this.$cookies.get("areaValue"));
              params.append("PNO", this.$cookies.get("partner"));
              params.append(
                "DbMapCountryRegionCode",
                this.$cookies.get("dbMapCode")
              );
              params.append("Nation", this.$cookies.get("nation"));
              params.append("Point", point);
              params.append("Creator", this.$cookies.get("LoginName"));
              params.append("ParKey", this.$cookies.get("areaValue"));

              params.append("loginType", this.$cookies.get("LoginType"));
              params.append("pwd", this.$cookies.get("pwd"));
              this.$axios({
                url: "/ElectronicFence/adD_tCd",
                method: "post",
                data: params,
                //   headers: {
                //     "Content-Type": "application/x-www-form-urlencoded"
                //   },
                withCredentials: true
              })
                .then(res => {
                  // console.log(res);
                  if (res.data.status == "success") {
                    // console.log(res.data.data);
                    // this.showLayer(this.value);
                    this.$message({
                      message: res.data.message,
                      type: "success"
                    });
                  } else {
                    this.$message({
                      message: res.data.message,
                      type: "fail"
                    });
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          }
        },
        rightclick: e => {
          showPoint = 0; //是否要抓取点坐标　0　表示不抓取点
          mouseTool.close(); //关闭绘图工具
          var SavePoint = this.SavePoint;
          // console.log(SavePoint);
          if (SavePoint == "") {
            return;
          }
          var p = "[" + SavePoint.substring(0, SavePoint.length - 1) + "]";
          var path = JSON.parse(p);
          if (path.length < 4) {
            this.reloadPage();
            this.$message.error(this.$t("message.fenceless"));
            return;
          }
          epolygon = new AMap.Polygon({
            path: path, //设置多边形边界路径
            strokeOpacity: 0.3, //线透明度
            strokeWeight: 1, //线宽
            fillOpacity: 0.3 //填充透明度
          });
          let map = amapManager.getMap();
          map.setDefaultCursor("pointer");
          epolygon.setMap(map);
          if (LayType == 3 || LayType == 5 || LayType == 2) {
            if (SavePoint != "") {
              this.OperatingArea = epolygon.getArea();
              this.saveLayer = true;
            }
          }
        }
      },
      options: [
        {
          value: "",
          label: this.$t("message.whole")
        },
        {
          value: "2",
          label: this.$t("message.jyParkArea")
        },
        {
          value: "3",
          label: this.$t("message.areaOut")
        },
        {
          value: "3.1",
          label: this.$t("message.areaIn")
        },
        {
          value: "5",
          label: this.$t("message.jtArea")
        },
        {
          value: "TCD",
          label: this.$t("message.parking")
        }
      ],
      value: "",
      value2: true,
      jjtArea: "",
      CanMove: false,
      inButton: true
    };
  },
  created() {
    this.loadPartner();
    this.loadInAct();
  },
  computed: {
    JYArea() {
      return this.$t("message.jyArea");
    },
    JTArea() {
      return this.$t("message.jtArea");
    },
    Park() {
      return this.$t("message.parking");
    },
    MoveCan() {
      if (this.value2 == true) {
        return this.$t("message.closeMove");
      } else {
        return this.$t("message.allowMove");
      }
    },
    showParK() {
      if (this.$cookies.get("LoginType") == "1") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    loadInAct() {
      if (this.$cookies.get("LoginType") == "1") {
        this.inButton = true;
      } else {
        this.inButton = false;
      }
    },
    onSearchResult(pois) {
      let map = amapManager.getMap();
      if (pois.length > 0) {
        map.panTo([pois[0].location.lng, pois[0].location.lat]);
      }
    },
    newGuid() {
      var guid = "";
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
      }
      return guid;
    },
    Drow(e, n, isOut) {
      LayType = n; //3 运营区域　5　禁停区域　1　停车点
      showPoint = 1; //是否需要抓取点　0　表示不抓取点

      if (n == 3 || n == 5 || n == 2) {
        //3 运营区域　5　禁停区域　要打开绘图工具　设置鼠标样式
        if (n == 5) {
          // var jtarea = this.jjtArea;
          //			console.log(jtarea);
          // if (parseInt(jtarea) > 99) {
          //   showPoint = 0;
          //   this.$message.error(this.$t("message.jtInfo"));
          //   return;
          // }
        }
        mouseTool.polygon(); //打开绘图工具
        // mouseTool.measureArea();
        let map = amapManager.getMap();
        map.setDefaultCursor("crosshair"); //设置鼠标指针样式
      }
      if (isOut == 3) {
        this.isOutterGeofencing = "yes";
      } else if (isOut == 3.1) {
        this.isOutterGeofencing = "no";
      }
    },
    loadPartner() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("partnerno", this.$cookies.get("pno"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/BiNdiNg_PartneR",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            this.partData = res.data.data;
            var partV = this.$cookies.get("partner");
            if (partV == null) {
              this.valuePa = this.partData[0].partnerNo;
            } else {
              this.valuePa = this.$cookies.get("partner");
            }
            this.$cookies.set("partner", this.valuePa);
            this.loadArea();
          } else if (res.data.status == "re_login") {
            this.soneIns = res.data.message;
            this.dialogOuti = true;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    loadArea() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerno", this.$cookies.get("partner"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/BiNdiNg_PartneR_aReA",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          this.areaData = res.data.data;
          var areaV = this.$cookies.get("areaValue");

          if (areaV == null) {
            this.valueAr = this.areaData[0].partnerareaguid;
          } else {
            for (var i = 0; i < this.areaData.length; i++) {
              if (
                this.areaData[i].partnerareaguid ==
                this.$cookies.get("areaValue")
              ) {
                this.valueAr = this.$cookies.get("areaValue");
              } else {
                this.valueAr = this.areaData[0].partnerareaguid;
              }
            }
          }
          this.$cookies.set("areaValue", this.valueAr);
          this.$cookies.set(
            "dbMapCode",
            this.areaData[0].dbmapcountryregioncode
          );
          this.$cookies.set("nation", this.areaData[0].nation);

          //调用接口
          this.loadData();
          this.loadLayer(this.PageType, "1");
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeHandler() {
      // this.$cookies.set("areaValue", areaVal);
      this.$cookies.set("partner", this.valuePa);
      this.loadArea();
    },
    changeArea() {
      this.$cookies.set("areaValue", this.valueAr);
      this.loadData();
      this.loadLayer(this.PageType, "1");
    },
    userOperation(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "editPsd":
          if (this.$cookies.get("LoginType") == "1") {
            this.$message.error(this.$t("message.marketNoPSD"));
            return;
          }
          this.formm.oldpsd = "";
          this.formm.newpsd = "";
          this.formm.surepsd = "";
          this.editPSDS = true;
          // console.log("编辑密码");
          break;
        case "editSecPsd":
          if (this.$cookies.get("LoginType") == "1") {
            this.$message.error(this.$t("message.marketNoSecPSD"));
            return;
          }
          this.formmSec.oldpsd = "";
          this.formmSec.newpsd = "";
          this.formmSec.surepsd = "";
          this.editSecPSDS = true;
          break;
      }
    },
    logout() {
      this.$cookies.set("SaveSiaLog", 2);
      this.$router.push("./login");
    },
    loadAgain() {
      this.loadPartner();
    },
    changeSecPsds() {
      if (this.formmSec.oldpsd == "") {
        this.$message.error(this.$t("message.oldSecPsdNo"));
        return;
      }
      if (this.formmSec.oldpsd != this.$cookies.get("saveSecond")) {
        this.$message.error(this.$t("message.psdNoOldPsd"));
        return;
      }
      if (this.formmSec.oldpsd.length < 6) {
        this.$message.error(this.$t("message.psdNolessBa"));
        return;
      }

      if (this.formmSec.newpsd == "") {
        this.$message.error(this.$t("message.newSecPsdNo"));
        return;
      }
      if (this.formmSec.newpsd.length < 6) {
        this.$message.error(this.$t("message.newSecNolessba"));
        return;
      }
      if (this.formmSec.newpsd != this.formmSec.surepsd) {
        this.$message.error(this.$t("message.surePsdNoNew"));
        return;
      }
      var randomNum = Math.random();
      var params = new URLSearchParams();
      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("oldSecondPwd", this.formmSec.oldpsd);
      params.append("newSecondPwd", this.formmSec.newpsd);
      // params.append(
      //   "secretKey",
      //   md5(this.GLOBAL.timestamp.toString() + randomNum.toString())
      // );
      // params.append("randomNum", randomNum);
      params.append("partnerGuid", this.$cookies.get("partner"));

      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/updateSecondPwd",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        // withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            this.editSecPSDS = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.$cookies.set("saveSecond", this.formmSec.newpsd);
            this.$cookies.set("SaveSiaLog", 2);
            // this.showTanS();
          } else {
            this.$message.error(res.data.message);
            this.$cookies.set("SaveSiaLog", 1);
            // this.showTanS();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadData() {
      this.WlName = "";
      this.areaDaa = "";
      this.jtDaa = "";
      this.parkDaa = "";
      this.jyDaa = "";
      let map = amapManager.getMap();
      // console.log(map);
      if (map != null) {
        map.clearMap(); // 清除地图覆盖物
      }
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("PNO", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/sHoW_GEofencIng_totalInfO",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data);
            var data = res.data.data[0];
            this.WlName = data.GeofencingName;
            var areass = parseFloat(data.AreaVal);
            this.areaDaa = areass.toFixed(2);
            this.jtDaa = data.JTTOTAL;
            this.parkDaa = data.TCDTOTAL;
            this.jyDaa = data.JYTOTAL;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    AddMark(guid, point, type) {
      var that = this;
      var extData = {};
      extData.Guid = guid;
      extData.type = type;
      console.log("啊23")
      var icon = new AMap.Icon({
        image: require("../../assets/4.png"),
        imageSize: new AMap.Size(10, 10)
      });
      let map = amapManager.getMap();
      var marker = new AMap.Marker({
        icon: icon,
        position: JSON.parse(point),
        draggable: false, //是否可拖动
        extData: extData,
        offset: new AMap.Pixel(-5, -5)
      });
      marker.setMap(map);
    },
    handleCloseFence(done) {
      this.$confirm(this.$t("message.isClose"))
        .then(_ => {
          this.value2 = true;
          this.CanMove = false;
          if (this.PageType != "-1") {
            this.loadLayer(this.PageType, "1");
          }
          location.reload();
          done();
        })
        .catch(_ => {});
    },
    handleCloseSLay(done) {
      this.$confirm(this.$t("message.isClose"))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    AddCircle(Point, size) {
      var point = Point.replace("[", "").replace("]", "");
      var circle = new AMap.Circle({
        center: new AMap.LngLat(point.split(",")[0], point.split(",")[1]), // 圆心位置
        radius: size * 1, //半径
        strokeColor: "#988FD8", //线颜色
        strokeOpacity: 0.3, //线透明度
        strokeWeight: 0.2, //线粗细度
        fillColor: "#988FD8", //填充颜色
        fillOpacity: 0.3, //填充透明度
        bubble: true
      });
      let map = amapManager.getMap();
      circle.setMap(map);
    },

    loadLayer(Optag, acTag) {
      var map = amapManager.getMap();
      map.clearMap(); // 清除地图覆盖物
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("Optag", Optag);
      params.append("PNO", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/SHow_Electronic_fence",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {        
            var data = res.data.data[0];
      

            let styleObject = [
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/BeaconParking.png", // 道钉点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 1,
                id: 1,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/AIspikeParking.png", // ai 点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 7,
                id: 7,
              },
            ];
            let TCDmarkerData = []
            let massMarks = new AMap.MassMarks([],{
                zIndex: 300,  // 海量点图层叠加的顺序
                zooms: [3, 19],  // 在指定地图缩放级别范围内展示海量点图层
                style: styleObject  // 设置样式对象
            });

            if (data != null) {
              for (var i = 0; i < data.length; i++) {
                if (
                  data[i].Type == 3 ||
                  data[i].Type == 5 ||
                  data[i].Type == 2 ||
                  data[i].Type == 3.1
                ) {
                  this.AddLayer(
                    data[i].GUID,
                    data[i].SOMEINFO,
                    data[i].ZB,
                    data[i].Type
                  );
                } 
                else if (data[i].Type == "TCD" && acTag == "1") {
                  let lnglat = data[i].ZB.split("'[")[0].split("]")[0].split("[")[1].split(",")
                  TCDmarkerData.push({
                    lnglat: [lnglat[0], lnglat[1]], //点标记位置
                    name: '停车点'+i,
                    id:i,
                    style: parseInt(data[i].DrawPointType),
                    guid:data[i].GUID,
                  })
                  // this.AddMark(data[i].GUID, data[i].ZB, "YS");
                  // this.AddCircle(data[i].ZB, data[i].SOMEINFO);
                }
              }
              if (Optag == "" || Optag == "3" || Optag == "5" || Optag == "2") {
                map.setZoom(13);
                if (data != null && data.length > 0) {
                  var n = data[0].ZB.split("],[")[0];
                  // console.log(JSON.parse(n + "]"));
                  map.panTo(JSON.parse(n + "]"));
                  // console.log(map);
                }
              } else if (Optag == "TCD") {
                if (data != null && data.length > 0) {
                  var n = data[0].ZB;
                  map.setZoom(13);
                  map.panTo(JSON.parse(n));
                }
              }

            }
            massMarks.setData(TCDmarkerData);
            massMarks.setMap(map);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    AddLayer(guid, name, point, LayerType) {
      var bubble = false;
      if (LayerType == "3") {
        bubble = true;
      }

      var color = "";
      if (LayerType == "5") {
        color = "#E27326";
      } else if (LayerType == "2") {
        color = "#00cc00";
      } else if (LayerType == "3") {
        // 外围栏
        // color = "#4E4D4D";
        color = "#0099FF"
      } else if (LayerType == "3.1") {
        // 内围栏
        // color = "#0D9BF2";
        color = "#CC99CC";
      }

      var extData = {};
      extData.Guid = guid;
      extData.Name = name;
      var p = "[" + point + "]";
      var path = JSON.parse(p);
      var polygon = new AMap.Polygon({
        path: path, //设置多边形边界路径
        strokeColor: color, //线颜色
        strokeOpacity: 0.3, //线透明度
        strokeWeight: 8, //线宽
        fillColor: color, //填充色
        fillOpacity: 0.4, //填充透明度
        extData: extData,
        bubble: bubble
      });
      let map = amapManager.getMap();
      polygon.setMap(map);
    },
    areaSHows(val) {
      if (val == 1) {
        // this.PageType = "3";
        this.loadLayer("3", "1");
        this.loadLayer("3.1", "1");
      } else if (val == 2) {
        this.PageType = "5";
        this.loadLayer(this.PageType, "1");
      } else if (val == 3) {
        this.PageType = "TCD";
        this.loadLayer(this.PageType, "1");
      } else {
        this.PageType = "2";
        this.loadLayer(this.PageType, "1");
      }
    },
    showALL() {
      this.PageType = "";
      this.loadLayer(this.PageType, "1");
    },
    EditMap() {
      this.editFence = true;
      this.showLayer(this.value);
    },
    showLayer(Optag) {
      let map = amapManager.getMap();
      //  var  mouseTool = new AMap.MouseTool(map);
      //  console.log(mouseTool);
      map.clearMap(); // 清除地图覆盖物
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("Optag", Optag);
      params.append("PNO", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/SHow_Electronic_fence",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          var oType;
          var jArr = [];
          if (res.data.status == "success") {
            var panLocation = res.data.data[0][0].ZB.split("],")[0] + "]";

            if (Optag == "TCD") {
              panLocation = res.data.data[0][0].ZB.split("],")[0];
            }
            let map = amapManager.getMap();
            // console.log(panLocation);
            map.panTo(JSON.parse(panLocation));
            var data = res.data.data[0];
            let styleObject = [
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/BeaconParking.png", // 道钉点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 1,
                id: 1,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/stopDian.png", // 普通点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 2,
                id: 2,
              },
              {
                url: "https://mimawximg.oss-cn-shanghai.aliyuncs.com/AIspikeParking.png", // ai 点图标地址
                size: new AMap.Size(30, 30), // 图标大小
                anchor: new AMap.Pixel(-8, -8), // 图标显示位置偏移量，基准点为图标左上角
                zIndex: 7,
                id: 7,
              },
            ];
            let TCDmarkerData = []
            let massMarks = new AMap.MassMarks(null,{
                zIndex: 80,  // 海量点图层叠加的顺序
                zooms: [3, 19],  // 在指定地图缩放级别范围内展示海量点图层
                style: styleObject  // 设置样式对象
            });

            if (data != null) {
              for (var i = 0; i < data.length; i++) {
                oType = data[i].Type;
                // if (oType == "3") {
                //   this.showAreaOut = false;
                // }
                if (this.$cookies.get("LoginType") == "1") {
                  if (oType == "3.1") {
                    this.showAreaIn = false;
                  } else {
                    this.showAreaIn = true;
                  }
                } else {
                  this.showAreaIn = false;
                }

                if (oType == "5") {
                  jArr.push("jt");
                }
                if (
                  data[i].Type == 3 ||
                  data[i].Type == 5 ||
                  data[i].Type == 2 ||
                  data[i].Type == 3.1
                ) {
                  this.eddLayer(
                    data[i].GUID,
                    data[i].SOMEINFO,
                    data[i].ZB,
                    data[i].Type
                  );
                } 
                else if (data[i].Type == "TCD") {
                  // this.eddMark(data[i].GUID, data[i].ZB);
                  let lnglat = data[i].ZB.split("'[")[0].split("]")[0].split("[")[1].split(",")
                  TCDmarkerData.push({
                    lnglat: [lnglat[0], lnglat[1]], //点标记位置
                    name: '停车点'+i,
                    id:i,
                    style: parseInt(data[i].DrawPointType),
                    guid:data[i].GUID,
                  })
                  
                  // this.AddCircle(data[i].ZB, data[i].SOMEINFO);
                }
              }
              console.log(TCDmarkerData)
              massMarks.setData(TCDmarkerData);
              massMarks.setMap(map);
              this.jjtArea = jArr.length;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    eddLayer(guid, name, point, LayerType) {
      var that = this;
      var bubble = false;
      if (LayerType == "3") {
        bubble = true;
      }

      var color = "";
      if (LayerType == "5") {
        color = "#E27326";
      } else if (LayerType == "2") {
        color = "#00cc00";
      } else if (LayerType == "3") {
        color = "#0099FF";
      } else if (LayerType == "3.1") {
        color = "#CC99CC";
      }

      var extData = {};
      extData.Guid = guid;
      extData.Name = name;
      extData.LayerType = LayerType;
      var p = "[" + point + "]";
      var path = JSON.parse(p);
      epolygon = new AMap.Polygon({
        path: path, //设置多边形边界路径
        strokeColor: color, //线颜色
        strokeOpacity: 0.3, //线透明度
        strokeWeight: 1, //线宽
        fillColor: color, //填充色
        fillOpacity: 0.4, //填充透明度
        extData: extData,
        bubble: bubble,
        zIndex: 100,
      });
      polygonAllArr.push(epolygon);
      epolygon.on("rightclick", function() {
        that.LayerRightClick(this);
      });
      epolygon.on("click", function() {
        // console.log("db");
        that.LayerdbClick(this);
      });
      let map = amapManager.getMap();
      epolygon.setMap(map);
    },
    LayerRightClick(e) {
      var layType = e.getExtData().LayerType;
      this.layGuid = e.getExtData().Guid;
      if (showPoint != 1) {
        if (layType == 3 || layType == 3.1) {
          this.delLAYs = false;
        } else {
          this.delLAYs = true;
        }
        this.editLayInput = e.getExtData().Name;
        this.editLayer = true;
      }
    },
    LayerdbClick(e) {
      var layType = e.getExtData().LayerType;
      // console.log(layType);
      if (layType == 3) {
        e.setOptions({
          zIndex: 8
        });
      }
      // console.log(polygonEditor);
      if (layType == 5 && polygonEditor == undefined) {
        let map = amapManager.getMap();
        // return;
        var that = this;
        that.editELEGuid = e.getExtData().Guid;
        // console.log(that.editELEGuid);
        polygonEditor = new AMap.PolyEditor(map, e);
        polygonEditor.open();
        // console.log(polygonEditor);
        AMap.event.addListener(polygonEditor, "end", function(res) {
          // console.log(res);
          var polygonArr = res.target.getPath();
          var SavePoint = that.SavePoint;
          // console.log(polygonArr);
          // console.log(SavePoint);
          for (var i = 0; i < polygonArr.length; i++) {
            SavePoint +=
              "[" + polygonArr[i].lng + "," + polygonArr[i].lat + "],";
          }
          // console.log(SavePoint);
          // console.log(that.SavePoint);
          that.SavePoint = SavePoint;
          if (SavePoint != "") {
            that.OperatingArea = epolygon.getArea();
            // console.log("type类型");
            // console.log(layType);
            // LayType = 3; //新注释

            LayType = layType;
            // console.log(that.OperatingArea);
            that.saveLayer = true;
          }
        });
      } else if (layType == 2 && polygonEditor == undefined) {
        let map = amapManager.getMap();
        // return;
        var that = this;
        that.editELEGuid = e.getExtData().Guid;
        // console.log(that.editELEGuid);
        polygonEditor = new AMap.PolyEditor(map, e);
        polygonEditor.open();
        // console.log(polygonEditor);
        AMap.event.addListener(polygonEditor, "end", function(res) {
          // console.log(res);
          var polygonArr = res.target.getPath();
          var SavePoint = that.SavePoint;
          // console.log(polygonArr);
          // console.log(SavePoint);
          for (var i = 0; i < polygonArr.length; i++) {
            SavePoint +=
              "[" + polygonArr[i].lng + "," + polygonArr[i].lat + "],";
          }
          // console.log(SavePoint);
          // console.log(that.SavePoint);
          that.SavePoint = SavePoint;
          if (SavePoint != "") {
            that.OperatingArea = epolygon.getArea();
            // console.log("type类型");
            // console.log(layType);
            // LayType = 3; //新注释

            LayType = layType;
            // console.log(that.OperatingArea);
            that.saveLayer = true;
          }
        });
      } else {
        // this.$message.error(this.$t("message.pleaseCJTEdit"));
      }
    },
    delLayer() {
      this.delTis = true;
    },
    suerDelete() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("GeofencingGuid", this.layGuid);
      params.append("ParKey", this.layGuid);
      params.append("FparkGuid", this.$cookies.get("areaValue"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/deleTe_ELectROnicFenCe",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data); //-201
            this.delTis = false;
            this.editLayer = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.reloadPage();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveLays() {
      if (this.editLayInput == "") {
        this.$message.error(this.$t("message.nameNoN"));
        return;
      }
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("GeofencingGuid", this.layGuid);
      params.append("loginUserName", this.$cookies.get("LoginName")); //??传空？
      params.append("GeofencingName", this.editLayInput);
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/eDit_eLectROnicFEnCename",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data); //-201 400 404
            this.editLayer = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.reloadPage();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    startEditYYPolygon(val) {
      let map = amapManager.getMap();
      var that = this;
      if (val == 3) {
        that.yyOutDisFive = false;
        that.yyInDisFive = true;
        that.isOutterGeofencing = "yes";
      } else if (val == 3.1) {
        that.yyInDisFive = false;
        that.yyOutDisFive = true;
        that.isOutterGeofencing = "no";
      }
      that.yyDisFive = false;
      that.jtDisFive = true;
      that.jyDisFive = true;
      for (var i = 0; i < polygonAllArr.length; i++) {
        if (polygonAllArr[i].getExtData().LayerType == val) {
          polygonEditor = new AMap.PolyEditor(map, polygonAllArr[i]);

          polygonEditor.open();
          // console.log(polygonEditor);
          AMap.event.addListener(polygonEditor, "end", function(res) {
            that.editELEGuid = "";
            var polygonArr = res.target.getPath();
            var SavePoint = that.SavePoint;
            for (var i = 0; i < polygonArr.length; i++) {
              SavePoint +=
                "[" + polygonArr[i].lng + "," + polygonArr[i].lat + "],";
            }
            // console.log(SavePoint);
            that.SavePoint = SavePoint;
            if (SavePoint != "") {
              that.OperatingArea = epolygon.getArea();
              LayType = 3; //新注释
              // if (polygonAllArr[i].getExtData().LayerType == "3") {
              //   LayType = 3;
              // } else {
              //   LayType = 5;
              // }
              // console.log(that.OperatingArea);
              that.saveLayer = true;
            }
          });
        }
      }
    },
    startEditJTPOlygon() {
      let map = amapManager.getMap();
      var that = this;
      that.yyInDisFive = true;
      that.yyOutDisFive = true;
      that.yyDisFive = true;
      that.jyDisFive = true;
      that.jtDisFive = false;
      // console.log(polygonAllArr);
      this.$message.error(this.$t("message.pleaseSBEdit"));
    },
    startEditJYPOlygon() {
      let map = amapManager.getMap();
      var that = this;
      that.yyInDisFive = true;
      that.yyOutDisFive = true;
      that.yyDisFive = true;
      that.jtDisFive = true;
      that.jyDisFive = false;
      // console.log(polygonAllArr);
      this.$message.error(this.$t("message.pleaseSBEdit"));
    },
    closeEditPolygon() {
      // console.log(polygonEditor);
      if (polygonEditor != undefined) {
        polygonEditor.close();
        polygonEditor = undefined;
        this.yyInDisFive = false;
        this.yyOutDisFive = false;
        this.yyDisFive = false;
        this.jtDisFive = false;
        this.jyDisFive = false;
      } else {
        this.$message.error(this.$t("message.pleaseCSEY"));
      }
    },
    eddMark(guid, point) {
      var that = this;
      var extData = {};
      extData.Guid = guid;
      console.log("lala")
      var icon = new AMap.Icon({
        image: require("../../assets/4.png"),
        imageSize: new AMap.Size(10, 10)
      });
      var marker = new AMap.Marker({
        icon: icon,
        position: JSON.parse(point),
        draggable: that.CanMove, //是否可拖动
        extData: extData,
        offset: new AMap.Pixel(-5, -5)
      });
      marker.on("rightclick", function() {
        that.markerRightClick(this);
      });
      marker.on("dragend", function() {
        that.markerdragend(this);
      });
      let map = amapManager.getMap();
      marker.setMap(map);
    },
    markerRightClick(e) {
      var that = this;
      that.radiusGuid = "";
      let map = amapManager.getMap();
      var guid = e.getExtData().Guid;
      that.radiusGuid = guid;
      var contextMenu = new AMap.ContextMenu(); //创建右键菜单
      contextMenu.addItem(
        that.$t("message.editsx"),
        function() {
          that.showEditPage(guid);
        },
        0
      );
      contextMenu.addItem(
        that.$t("message.dele"),
        function() {
          that.delPoint();
        },
        1
      );

      contextMenu.open(map, e.getPosition());
    },
    switchChange() {
      // console.log(this.value2);
      if (this.value2 == false) {
        this.CanMove = true;
        this.reloadPage();
      } else {
        this.CanMove = false;
        this.reloadPage();
      }
    },
    markerdragend(e) {
      this.moveRadius = true;
      this.moveGuid = "";
      this.nEwpoint = "";
      var guid = e.getExtData().Guid;
      this.moveGuid = guid;
      var Lon = e.getPosition().getLng();
      var Lat = e.getPosition().getLat();
      var newpoint = "[" + Lon + "," + Lat + "]";
      this.nEwpoint = newpoint;
    },
    moveRaduis() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("PointCoordinate", this.nEwpoint);
      params.append("Creator", this.$cookies.get("LoginName"));
      params.append("PointGuid", this.moveGuid);
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/MOVe_tCd",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data); -201
            this.moveRadius = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.reloadPage();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showEditPage(guid) {
      this.editRadius = true;
      this.loadRadius(guid);
    },
    loadRadius(pointGuid) {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("PointGuid", pointGuid);
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/shOW_TCD_SOMe_iNFO",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data); //返回的字符串
            var data = JSON.parse(res.data.data);
            // console.log(data);
            this.form.name = data.PropertyName;
            this.form.radius = data.PointRadius;
            this.form.rems = data.PropertyRemark;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    SaveEditForm() {
      if (this.form.name == "") {
        this.$message.error(this.$t("message.penterName"));
        return;
      }
      if (this.form.radius == "") {
        this.$message.error(this.$t("message.enterBanj"));
        return;
      }
      if (
        this.GLOBAL.IntRegst.test(this.form.radius) === false &&
        this.GLOBAL.DoubleRegst.test(this.form.radius) === false
      ) {
        this.$message.error(this.$t("message.BanjRegErr"));
        return;
      }
      if (parseInt(this.form.radius) < 10) {
        this.$message.error(this.$t("message.BanjLesten"));
        return;
      }
      if (parseInt(this.form.radius) > 1000) {
        this.$message.error(this.$t("message.BanjMorooo"));
        return;
      }
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("pointradius", this.form.radius);
      params.append("Creator", this.$cookies.get("LoginName"));
      params.append("PointGuid", this.radiusGuid);
      params.append("Name", this.form.name);
      params.append("Rem", this.form.rems);
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/EDIt_TCD",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data); -201
            this.editRadius = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.reloadPage();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    delPoint() {
      // console.log("del");
      this.delRadius = true;
    },
    deleRadius() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("PointGuid", this.radiusGuid);
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/dEletE_Tcd",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.delRadius = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.reloadPage();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancelDelRadius() {
      this.delRadius = false;
    },
    cancelMovRadius() {
      this.moveRadius = false;
      this.reloadPage();
    },
    changeWL() {
      // console.log(this.value);
      if (this.value == "5") {
        this.showLayer("5");
        this.showLayer("TCD");
      } else if (this.value == "2" || this.value == "TCD") {
        this.showLayer("2");
        this.showLayer("TCD");
      } else {
        this.showLayer(this.value);
      }
    },
    CloseEditForm() {
      this.editRadius = false;
    },
    CloseForm() {
      this.saveLayer = false;
      this.reloadPage();
    },
    CloseLForm() {
      this.editLayer = false;
      this.reloadPage();
    },
    SaveLForm() {
      // console.log(LayType);
      var snameInput = this.snameInput;
      if (snameInput == "") {
        this.$message.error(this.$t("message.nameNoN"));
        return;
      }
      var squery = this.OperatingArea * 0.000001;
      // console.log(this.OperatingArea);
      // console.log(squery);
      var electronicURL = "/ElectronicFence/AdD_elEctronic_FenCe";
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("PNO", this.$cookies.get("partner"));
      params.append("Creator", this.$cookies.get("LoginName"));
      params.append("Point", this.SavePoint);
      params.append("Title", snameInput);
      params.append("geofencingType", LayType);
      params.append("limitCount", "20000");
      params.append("squery", squery);
      params.append("ParKey", this.$cookies.get("areaValue"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      params.append("isOutterGeofencing", this.isOutterGeofencing);

      if (this.editELEGuid != "") {
        params.append("guid", this.editELEGuid);
        electronicURL = "/ElectronicFence/eDIT_elEctronic_FenCe";
      }
      // console.log(this.editELEGuid);
      // console.log(electronicURL);
      // return;
      this.$axios({
        url: electronicURL,
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.yyInDisFive = false;
            this.yyOutDisFive = false;
            this.yyDisFive = false;
            this.jtDisFive = false;
            this.jyDisFive = false;
            this.editELEGuid = "";
            this.snameInput = "";
            this.saveLayer = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            if (LayType == 2) {
              let map = amapManager.getMap();
              map.setDefaultCursor("pointer"); //设置鼠标指针样式
              LayType = -1; //绘制图层类型
              showPoint = 0; //是否正在抓取点坐标　0　表示不抓取点
              this.SavePoint = "";
              mouseTool.close();
            } else {
              this.reloadPage();
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    reloadPage() {
      let map = amapManager.getMap();
      map.setDefaultCursor("pointer"); //设置鼠标指针样式
      LayType = -1; //绘制图层类型
      showPoint = 0; //是否正在抓取点坐标　0　表示不抓取点
      this.SavePoint = "";
      mouseTool.close();
      this.showLayer(this.value);
    },
    changePsds() {
      if (this.formm.oldpsd == "") {
        this.$message.error(this.$t("message.oldPSDNON"));
        return;
      }
      if (this.formm.oldpsd != this.$cookies.get("oldPassword")) {
        this.$message.error(this.$t("message.enternosame"));
        return;
      }
      // if (this.formm.oldpsd.length < 6) {
      //   this.$message.error(this.$t("message.oldPSDNSix"));
      //   return;
      // }

      if (this.formm.newpsd == "") {
        this.$message.error(this.$t("message.newPSDNON"));
        return;
      }
      // if (this.formm.newpsd.length < 6) {
      //   this.$message.error(this.$t("message.oldPSDNSix"));
      //   return;
      // }
      if (this.formm.newpsd != this.formm.surepsd) {
        this.$message.error(this.$t("message.psdNoSame"));
        return;
      }
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("oldPwd", this.formm.oldpsd);
      params.append("newPwd", this.formm.newpsd);
      params.append("partnerGuid", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/EdiT_PaSsWoRd",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.editPSDS = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            setTimeout(() => {
              this.$router.push("./login");
            }, 2000);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  components: {
    SelectMenu,
    SelectMen,
    LangSelect,
    ElectricFCard
  }
};
</script>
<style>
.Elecheader {
  height: 64px;
  background: #000;
}
.Elecsel {
  float: right;
  color: #fff;
  padding-top: 12px;
}
.Elecmain {
  padding-left: 20px;
  padding-top: 10px;
}
.elecBbb {
  width: 140px !important;
}
.map {
  background: #fff;
  width: 100%;
  height: 100%;
}
.amap-wrapper {
  width: 100%;
}
.editMaps {
  width: 100%;
  height: 710px;
  position: relative;
}
.FindsearchBox {
  width: 300px !important;
  height: 40px;
  line-height: 40px;
  border: none;
  position: absolute;
  top: 160px;
  left: 76px;
  z-index: 99;
}
.BtnBox {
  height: 40px;
  line-height: 40px;
  border: 1px solid #a3ccff;
  position: absolute;
  top: 167px;
  left: 96px;
  background-color: #ffffff;
  z-index: 99;
}
.hz,
.switch {
  margin: 0 5px;
}
.setInput {
  width: 200px !important;
  margin-left: 10px;
}
.saveBtnG {
  margin-top: 10px;
  text-align: right;
}
.s1{
  margin-right: 2%;
  font-size: 20px;
}
.Moving {
  margin-right: 4px;
}
.boxFot {
  width: 74%;
  position: absolute;
  top: 20px;
  left: 10%;
}
.boxTox {
  width: 100%;
}
.ftAreaIn {
  width: 35px;
  height: 10px;
  background: #0d9bf2;
  display: inline-block;
}
.ftAreaOut {
  width: 35px;
  height: 10px;
  background: #0099FF;
  display: inline-block;
}
.ftAreaOut1 {
  width: 35px;
  height: 10px;
  background: #CC99CC;
  display: inline-block;
}
.ftAreaJT {
  width: 35px;
  height: 10px;
  background: #e27326;
  display: inline-block;
}
.ftAreaJY {
  width: 35px;
  height: 10px;
  background: #00cc00;
  display: inline-block;
}
</style>
